import { Link } from "react-router-dom";
import { deltaTone, fmtDelta } from "@/lib/format";

interface Props {
  label: string;
  value: string;
  hint?: string;
  deltaPct?: number | null;
  loading?: boolean;
  to?: string;
}

export default function KpiTile({ label, value, hint, deltaPct, loading, to }: Props) {
  const tone = deltaTone(deltaPct);
  const toneClass =
    tone === "up" ? "text-success" : tone === "down" ? "text-danger" : "text-ink-500";

  const inner = (
    <>
      <div className="stat-label">{label}</div>
      {loading ? (
        <div className="mt-2 h-9 w-24 animate-pulse rounded bg-ink-100" />
      ) : (
        <div className="mt-2 stat-value">{value}</div>
      )}
      <div className="mt-1 flex items-baseline gap-2 text-xs">
        {deltaPct != null && (
          <span className={`font-medium tabular-nums ${toneClass}`}>{fmtDelta(deltaPct)}</span>
        )}
        {hint && <span className="text-ink-500">{hint}</span>}
      </div>
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="card block p-6 transition hover:border-accent-300 hover:shadow-sm"
      >
        {inner}
        <span className="mt-2 block text-xs font-medium text-accent-600">View customers →</span>
      </Link>
    );
  }

  return <div className="card p-6">{inner}</div>;
}
